import { Loading } from '@arcadiapower/shrike';
import { range } from 'lodash';
import { useState, useRef, useEffect } from 'react';
import { pdfjs } from 'react-pdf';
import { trackError } from '~/utils/tracking';
import { DocumentWrapper, StyledPage, PdfWrapper } from './scrollable-pdf.style';

interface ScrollablePdfProps {
  pdfUrl: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const ScrollablePdf = ({ pdfUrl }: ScrollablePdfProps) => {
  const [numPages, setNumPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [width, setWidth] = useState(0);

  const ref = useRef<HTMLDivElement>(null);

  const updateWidth = () => {
    const { current } = ref;
    if (!current) return;

    setWidth(current.clientWidth);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setLoading(false);
    setNumPages(numPages);
  };

  const handleError = error => {
    setLoading(false);
    trackError(error); // Sends error to segment
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
  });

  return (
    <PdfWrapper ref={ref} className="notranslate">
      <DocumentWrapper file={pdfUrl} onError={handleError} onLoadSuccess={onDocumentLoadSuccess}>
        {loading ? (
          <Loading />
        ) : (
          range(1, numPages + 1).map(pageNum => (
            <StyledPage
              pageNumber={pageNum}
              key={pageNum}
              width={width}
              onLoadSuccess={updateWidth}
              onError={handleError}
            />
          ))
        )}
      </DocumentWrapper>
    </PdfWrapper>
  );
};
